import BaseComponent from "@js/components/base_component.jsx";
import QrCodeLibrary from "qrcode";

class QrCode extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      svg: null,
    };
  }

  componentDidMount() {
    this._renderSvg();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ( this.props.url !== prevProps.url ) {
      this._renderSvg();
    }
  }

  render() {
    return (
      <div
        style={{ textAlign: "center" }}
        id="qr-code-svg"
      >
        {
          this.state.svg ? (
            <div
              dangerouslySetInnerHTML={{ __html: this.state.svg }}
              style={{ width: this._svgWidth(), display: "inline-block" }}
            />
          ) : (
            "loading qrcode"
          )
        }
      </div>
    );
  }

  _renderSvg() {
    QrCodeLibrary.toString(this.props.url, { type: "svg" }, (err, svg) => {
      if ( !err && svg ) {
        this.setState({
          svg: svg,
        });
      }
    });
  }

  _svgWidth() {
    if ( this.props.width ) {
      return "" + this.props.width + "px";
    } else {
      return "200px";
    }
  }

}

export default QrCode;
